<template>
  <CRow>
    <CCol col="6">
      <CCard>
        <loader v-show="loading"/>
        <CCardHeader> <CIcon name="cil-grid" />Add User
        </CCardHeader>
        <CCardBody>
          <div class="form-group">
            <label>Nama</label>
            <input type="text" class="form-control" v-model="data.name">
            <message-container :data="errors.name" />
          </div>
          <div class="form-group">
            <label>Email</label>
            <input type="text" class="form-control" v-model="data.email">
            <message-container :data="errors.email" />
          </div>
          <button v-show="!resetPass(data)" class="btn btn-outline-primary" @click="doReset">Reset Password</button>
          <div v-show="resetPass(data)">
            <div class="form-group">
              <label>Password</label>
              <input type="text" class="form-control" v-model="data.password">
              <message-container :data="errors.password" />
            </div>
            <div class="form-group">
              <label>Konfirmasi Password</label>
              <input type="text" class="form-control" v-model="data.password_confirmation">
              <message-container :data="errors.password" />
            </div>
          </div>
          <button v-show="resetPass(data)" class="btn btn-outline-danger" @click="cancelReset">Cancel Reset Password</button>
        </CCardBody>
        <CCardFooter>
          <btn-save-update :data="data" @back="doBack" @save="doSave" @update="doUpdate"/>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import BtnSaveUpdate from "../../components/BtnSaveUpdate";
import MessageContainer from "../../components/MessageContainer";
import { showErrorMessage } from '../../lib/helpers';
import Loader from '../../components/Loader.vue';
export default {
  components: {
    BtnSaveUpdate,
    MessageContainer,
    Loader,
  },
  data() {
    return {
      loading: false,
      data: {
        domain: "Admin",
        raw_input: "Register by Admin"
      },
      errors: [],
      reset: false,
    };
  },
  created() {
    const query = this.$route.query
    if (query && query.id && query.id != 'new') {
      this.get(query.id)
    }
  },
  methods: {
    get(id) {
      HTTPAUTH.get("/api/v1/admin/user/" + id).then(resp => {
        this.data = resp.data.data;
      })
    },
    doBack() {
      this.$router.push({path: "/user/list"})
    },
    doSave() {
      this.loading = true;
      HTTPAUTH.post("/api/v1/auth/register", this.data).then(res=> {
        this.data = res.data.data
        this.loading = false;
        this.$toasted.success("Tambah User berhasil").goAway();
        this.get(this.data.id)
      }).catch(eres => {
        this.errors = showErrorMessage(eres)
        this.loading = false;
      })
    },
    doUpdate() {
      if (this.reset) {
        this.saveResetPass();
      }
      this.loading = true;
      HTTPAUTH.put(`/api/v1/auth/user/${this.data.id}/edit`, this.data).then(res=> {
        this.data = res.data.data
        this.loading = false;
        this.$toasted.success("User berhasil diubah").goAway();
        this.get(this.data.id)
      }).catch(eres => {
        this.errors = showErrorMessage(eres)
        this.loading = false;
      })
    },
    saveResetPass() {
      this.loading = true;
      HTTPAUTH.put("/api/v1/admin/user/reset-password", this.data).then(()=> {
        this.loading = false;
        this.$toasted.success("Tambah User berhasil").goAway();
      }).catch(eres => {
        this.errors = showErrorMessage(eres)
        this.loading = false;
      }) 
    },
    resetPass(data) {
      return (data.id && this.reset) || (!data.id && !this.reset)
    },
    doReset() {
      this.reset = true;
    },
    cancelReset() {
      this.reset = false;
    },
  },
  filters: {
  }
};
</script>